import React from 'react';

import { ParsedData } from '@betterment/js-runtime';

import { Customer } from '../data';

export interface AppCustomerContext {
  customer: Customer;
  refetch: () => Promise<ParsedData<Customer>>;
}

const noop = () => Promise.resolve({} as ParsedData<Customer>);

export const CustomerContext = React.createContext<AppCustomerContext>({} as AppCustomerContext);

const CustomerProvider: React.FC<
  React.PropsWithChildren<
    Omit<AppCustomerContext, 'refetch'> & {
      refetch?: AppCustomerContext['refetch'];
    }
  >
> = ({ children, customer, refetch = noop }) => {
  const values = React.useMemo(() => ({ customer, refetch }), [customer, refetch]);
  return <CustomerContext.Provider value={values}>{children}</CustomerContext.Provider>;
};

export const useCustomer = () => {
  const context = React.useContext(CustomerContext);
  if (!context) {
    throw new Error('useCustomer must be used under CustomerProvider');
  }
  return context;
};

export default CustomerProvider;
